import styled from 'styled-components';
import { Button } from '@app/src/common/Button';

export const ButtonPrevWrapper = styled(Button)`
  height: 55px;
  font-size: 14px;
  font-weight: 600;
  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
  span {
    text-align: left;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  height: 55px;
  font-size: 14px;
  font-weight: 600;
  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;